import { render, staticRenderFns } from "./UrbanismRegulationsForm.vue?vue&type=template&id=e3e6cb40&scoped=true&"
import script from "./UrbanismRegulationsForm.vue?vue&type=script&lang=js&"
export * from "./UrbanismRegulationsForm.vue?vue&type=script&lang=js&"
import style0 from "./UrbanismRegulationsForm.vue?vue&type=style&index=0&id=e3e6cb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e6cb40",
  null
  
)

export default component.exports